<template>
    <div>
        <div class="notify-admin" @focusout="closeNoti()"
        tabindex="-1" >
            <div :class="['on-hover',{'group-notify-active': active}]" @click="onClick()">
                <i id="new-message" class="fas fa-circle" v-show="newMessage"></i>
                <i id="btn-notify" class="far fa-bell"></i>
            </div>
            <template v-if="active">
                <div class="notify-box">
                <div id="notify-triangle">
                    <i class="fas fa-caret-up"></i>
                </div>
                <div class="col-lg-12">
                    <div class="list-order header row">
                        <div class="col-6 d-flex align-items-center">
                            <h3>การแจ้งเตือน</h3>
                        </div>
                        <div class="d-flex align-items-center justify-content-end col-6">
                            <label class="text-muted">{{checktotalItem}} รายการ</label>
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <template v-if="checktotalItem"> 
                        <div 
                            class="on-hover list-order row" v-for="(data , index) in dataNotify" :key="index" @click="selectedNotify( data.url )"
                        >
                            <div class="col-lg-2 py-2 d-flex justify-content-center align-items-center">
                                <i :class="`fas custom-icon ${getIcon( data.type )}`"></i>
                            </div>
                            <div class="col-lg py-2">
                                <p class="blod msg-noti">{{data.title}}</p>
                                <p class="msg-noti">{{data.text}}</p>
                                <p class="msg-noti text-muted">{{data.created_at}}</p>
                            </div>
                        </div>
                    </template>
                    <template v-if="!checktotalItem && !isload">
                        <div class="row">
                            <div class="col-lg-12 p-3 d-flex justify-content-center align-items-center">
                                <h4>ไม่มีการแจ้งเตือน</h4>
                            </div>
                        </div>
                    </template>
                    <template v-if="isload">
                        <div class="row">
                            <div class="col-lg-12 p-4 d-flex justify-content-center align-items-center">
                                <div class="box-loading">
                                    <div class="loading-notify" ></div>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
                <div class="col-12">
                    <div class="row">
                        <div class="d-flex justify-content-center align-items-center col-lg-12 p-1">
                            <div 
                                :class="[{'on-click on-hover':checkLoadMore , 'disabled':!checkLoadMore}]" 
                                @click="loadMore()"
                            >
                                <label class="m-1 blod">โหลดข้อมูลเพิ่มเติม</label>
                                <i class="fas fa-caret-down m-1 on-click"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </template>
        </div>
    </div>
</template>
<script>
import checkTypeIcon from "@/components/NotificationPlugin/js/type-icon.js"
import { setCookie } from "@/helpers/util"

export default {
    name: "NotificationBell",
    props: { dataNotify: Array , paginate: Object , isload: Boolean , newMessage: Boolean, setNewMessage: Function },
    data(){
        return {
            active: false,
        }
    },
    methods:{

        getIcon( type ){

            return checkTypeIcon( type )
        },

        closeNoti(){

            this.active = false

        },
        onClick(){
            
            this.active =  !this.active
            this.setNewMessage(false)
            setCookie('read_noti', this.moment().valueOf(), 50)
        },
        loadMore(){

            if( this.checkLoadMore ){

                this.paginate.page += 1

            }
        },
        selectedNotify( url ){

            this.$router.push({ name: url })
            this.closeNoti()
        }
    },
    computed:{
        checkLoadMore(){

            return this.paginate.totalPage > 1 && this.paginate.totalPage != this.paginate.page ? true : false

        },
        checktotalItem(){

            return this.dataNotify.length

        }
    }
    
}
</script>
<style lang="scss" scoped>

    .msg-noti{
        margin:0;
        line-height: 23px;
    }
    .disabled{
        color:#8898aa;
    }
    .blod{
        font-weight: bold;
    }
    .fas.fa-caret-up{
        color: #f7f4f4;
    }
    .custom-icon{
        font-size: xx-large;
    }
    #notify-triangle{

        position: absolute;
        top: -15px;
        left: auto;
        right: 3px;

    }

    .list-order{
        border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    }
    .notify-box{
        border-radius: 4px;
        margin-top: 0.5rem;
        position: absolute;
        left: auto;
        right: 0;
        min-width: 25rem;
        max-height: 30rem;
        overflow: auto;
        background: #FFFFFF;
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
        border-radius: 6px;
        .header {
            padding: 0.5rem;
        }
    }

    #btn-notify{

        // color:whitesmoke;

    }
    
    #new-message{

        position: absolute;
        top: 4px;
        left: 8px;
        color: red;
        font-size: 11px;
        animation: sonar 1.2s 3;

    }
    .group-notify-active{

        opacity: 0.8;

    }
    .on-hover{

        cursor: pointer;

        &.list-order{
            &:hover{
                background: #f7f4f4c7;
            }
            &:active{
                opacity: 0.3;
            }
        }

        &.on-click{

             &:active{
                 color: #0000004f;
            }
        }

        label{
            cursor: pointer
        }
        
    }
    .notify-admin{

        position: relative;

    }
    .loading-notify {

        position: absolute;
        display: inline-block;
        border: 4px solid #dad7d7;
        border-top: 4px solid #3498db;
        border-radius: 100%;
        width: 2rem;
        height: 2rem;
        animation: spin 2s linear infinite;
        z-index: 100;
    }
    .box-loading{
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        background-color: #FFFFFF;
        z-index:99;
    }

    @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}
    @keyframes sonar { 
        0% {transform: scale(.9); opacity:1;}
        100% {transform: scale(1);opacity: 0.5;}
    }
</style>